<template>
  <div>
    <q-form ref="adicionarAtividadeForm" class="row">
      <div
        class="row col-12 text-brand-5 text-weight-bold text-body q-gutter-x-xs"
      >
        <div class="col-md-3 col-sm-12 col-xs-12">
          <div class="q-ml-sm titulo-input">Nome da Atividade</div>
          <q-input
            class="col-xs-12 col-sm-6 col-md-4 input-atividade"
            dense
            outlined
            v-model="adicionarAtividadeDto.nome"
            :rules="[(val) => (val && val.length > 0) || 'Campo Obrigatório']"
          />
        </div>

        <div class="toggle-container q-ml-lg">
          <div class="q-ml-xs titulo-toggle">
            Atividade <span class="text-red">Crítica ?</span>
          </div>
          <q-radio
            v-model="adicionarAtividadeDto.critico"
            :val="true"
            label="Sim"
            color="brand-4"
            class="radio"
          ></q-radio>
          <q-radio
            v-model="adicionarAtividadeDto.critico"
            :val="false"
            label="Não"
            color="brand-4"
            class="radio q-ml-lg"
          ></q-radio>
        </div>
        <div class="toggle-container q-mx-lg">
          <div class="q-ml-xs titulo-toggle">
            Atividade <span class="text-red">Obrigatória ?</span>
          </div>
          <q-radio
            v-model="adicionarAtividadeDto.obrigatorio"
            :val="true"
            label="Sim"
            color="brand-4"
            class="radio"
          ></q-radio>
          <q-radio
            v-model="adicionarAtividadeDto.obrigatorio"
            :val="false"
            label="Não"
            color="brand-4"
            class="q-ml-lg radio"
          ></q-radio>
        </div>
        <div class="btn-mobile">
          <p></p>
          <q-btn
            class="q-mt-sm btn-adicionar"
            label="Adicionar Atividade"
            no-caps
            dense
            icon="add_circle_outline"
            color="primary"
            @click="adicionarAtividade"
          />
        </div>
        <div class="col-lg-2 col-md-3 col-sm-6 col-xs-6 mobile q-ml-md">
          <p></p>
          <q-btn
            class="q-mt-sm"
            label="Upload em Massa"
            no-caps
            dense
            outline
            icon="file_download"
            style="color: #1647cf"
            @click="upload = true"
          />
        </div>
      </div>
    </q-form>
    <q-dialog v-model="upload">
      <q-card style="width: 800px">
        <q-card-section>
          <div class="text-h6 text-brand-5 text-weight-bold">
            <span>Upload de Atividades em Massa</span>
            <q-icon
              class="q-ml-sm"
              name="info"
              style="cursor: pointer"
              @click="informacaoUpload = true"
            />
          </div>
        </q-card-section>

        <q-separator />
        <q-card-section style="height: 50vh">
          <div>
            <div
              class="row col-12 text-brand-5 text-weight-bold q-gutter-x-sm input-arquivo-container"
            >
              <div style="margin-top: 31px" class="container">
                <label class="btn info" for="arquivo">
                  Selecionar Arquivo</label
                >
                <div
                  class="text-brand-5 text-weight-bold text q-ml-sm input-arquivo-text"
                >
                  {{ file ? file.name : "Nenhum arquivo escolhido" }}
                </div>
                <input
                  id="arquivo"
                  type="file"
                  @change="onFileSelected"
                  @click="resetValue()"
                />
                <span class="icon">
                  <img src="../../../../assets/file_upload_black.svg" alt="" />
                </span>
              </div>
              <div class="btn-enviar-container">
                <p></p>
                <q-btn
                  class="q-mt-sm"
                  label="Enviar"
                  color="positive"
                  no-caps
                  v-close-popup
                  dense
                  icon="check_circle_outline"
                  @click="uploadCsv()"
                />
              </div>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog v-model="informacaoUpload">
      <q-card style="width: 80%">
        <div class="q-gutter-md">
          <q-carousel
            v-model="slide"
            transition-prev="scale"
            transition-next="scale"
            swipeable
            animated
            control-color="white"
            navigation
            padding
            arrows
            height="300px"
            class="bg-brand-1 text-white shadow-1 rounded-borders"
          >
            <q-carousel-slide :name="0" class="column no-wrap flex-center">
              <a
                download
                href="https://multpex-docs.s3.amazonaws.com/templates/pt_digital/Questiona%CC%81rio_de_risco_PT.csv"
              >
                <q-icon name="file_download" size="56px" />
              </a>
              <div class="q-mt-md text-center">
                <div>
                  Clique no icone para baixar o modelo mais atualizado do
                  template
                </div>
              </div>
            </q-carousel-slide>
          </q-carousel>
        </div>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { useQuasar } from "quasar";
import { ref, watch } from "vue";
import { useStore } from "vuex";

export default {
  props: ["unidadeId"],
  emits: ["atualizar"],
  setup(props, { emit }) {
    const store = useStore();
    const quasar = useQuasar();
    const adicionarAtividadeForm = ref(null);
    let adicionarAtividadeDto = ref({
      nome: "",
      critico: "",
      obrigatorio: "",
    });
    const csvURL = ref("");
    const upload = ref(false);
    const file = ref(null);
    let informacaoUpload = ref(false);
    const slide = ref(0);

    const adicionarAtividade = async () => {
      const valido = await adicionarAtividadeForm.value.validate();
      if (!valido || adicionarAtividadeDto.value.critico === "") {
        quasar.notify({
          message: "Preencha todos os campos",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
            },
          ],
        });
        return;
      }

      try {
        await store.dispatch("pdt/adicionarAtividade", {
          unidadeId: props.unidadeId,
          nome: adicionarAtividadeDto.value.nome,
          critico: adicionarAtividadeDto.value.critico,
          obrigatorio: adicionarAtividadeDto.value.obrigatorio,
        });

        quasar.notify({
          message: "Atividade adicionada",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
            },
          ],
        });
        resetForm();
        emit("atualizar");
      } catch (error) {
        let message = "Ocorreu um erro ao adicionar a atividade";
        if (error.response) {
          message = error.response.data.erros;
        }
        console.log(error);

        quasar.notify({
          message,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
            },
          ],
        });
      }
    };

    const resetForm = () => {
      adicionarAtividadeDto.value = {
        nome: "",
        tipo: "atividade",
        critico: "",
      };
      adicionarAtividadeForm.value.reset();
    };

    let onFileSelected = async (e) => {
      if (e.target.files[0].length === 0) {
        return;
      }
      file.value = e.target.files[0];
    };

    watch(
      () => file.value,
      () => {
        let fileReader = new FileReader();

        fileReader.readAsDataURL(file.value);
        fileReader.addEventListener("load", () => {
          csvURL.value = fileReader.result;
        });
      }
    );

    const uploadCsv = async () => {
      if (file.value.name.split(".").pop() != "csv") {
        quasar.notify({
          message: "O arquivo tem que ser do tipo .csv",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        await store.dispatch("pdt/uploadCsv", {
          unidadeId: props.unidadeId,
          arquivoCsv: csvURL.value,
        });
        quasar.notify({
          message: "Atividades adicionadas com sucesso",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        emit("atualizar");
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao adicionar atividades",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const resetValue = () => {
      const input = document.getElementById("arquivo");
      input.value = null;
    };

    return {
      adicionarAtividadeForm,
      adicionarAtividadeDto,
      adicionarAtividade,
      upload,
      file,
      onFileSelected,
      uploadCsv,
      csvURL,
      informacaoUpload,
      slide,
      resetValue,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
  color: white;
}
input[type="file"] {
  display: none;
}
.btn {
  border: 2px solid black;
  background-color: white;
  color: black;
  border-radius: 5px;
  margin: 5px 5px 0 0;
  padding: 6px 20px;
  padding-left: 40px;
  cursor: pointer;
  border-color: #2196f3;
  color: #58afc1;
}
.info {
  border-color: #58afc1;
}
.text {
  display: inline;
}
.container {
  position: relative;
}
.icon {
  position: absolute;
  top: -2px;
  left: 9px;
}
@media (max-width: 600px) {
  .titulo-input {
    margin: 0px;
    font-size: 12px;
  }
  .titulo-toggle {
    font-size: 11px;
  }
  .toggle-container {
    margin: 5px;
  }
  .mobile {
    display: none;
  }
  .btn-adicionar {
    font-size: 12px;
    margin: 0px;
  }
  .radio {
    font-size: 11px;
  }
  .input-atividade {
    font-size: 16px !important;
  }
  .btn-mobile {
    width: 100%;
  }
}
</style>
